import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "199",
  height: "207.178",
  viewBox: "0 0 199 207.178"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "0",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "1",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["stop-color"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "1",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_9 = ["id"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "0",
  "stop-color": "#0f0f0f"
}, null, -1)
const _hoisted_11 = ["stop-color"]
const _hoisted_12 = {
  id: "quanquan",
  transform: "translate(-88 -112)"
}
const _hoisted_13 = ["stroke"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "99.5",
  cy: "10.976",
  rx: "99.5",
  ry: "10.976",
  stroke: "none"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "99.5",
  cy: "10.976",
  rx: "99",
  ry: "10.476",
  fill: "none"
}, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["fill"]
const _hoisted_18 = ["fill", "stroke"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("g", { opacity: "0.1" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "91",
    cy: "91",
    r: "91",
    stroke: "none"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "91",
  cy: "91",
  r: "90.5",
  fill: "none"
}, null, -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = ["fill"]
const _hoisted_23 = ["fill"]
const _hoisted_24 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'survey-svg-1',
  props: {
    controlColor: { default: 'var(--theme-color-1,#000)' },
    numbers: { default: 1 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: `survey-svg-1-linear-gradient${_ctx.numbers}`,
        x1: "0.5",
        x2: "0.5",
        y2: "0.58",
        gradientUnits: "objectBoundingBox"
      }, _hoisted_5, 8, _hoisted_2),
      _createElementVNode("linearGradient", {
        id: `survey-svg-1-linear-gradient-2${_ctx.numbers}`,
        x1: "0.5",
        x2: "0.5",
        y2: "1",
        gradientUnits: "objectBoundingBox"
      }, [
        _createElementVNode("stop", {
          offset: "0",
          "stop-color": _ctx.controlColor
        }, null, 8, _hoisted_7),
        _hoisted_8
      ], 8, _hoisted_6),
      _createElementVNode("linearGradient", {
        id: `survey-svg-1-linear-gradient-3${_ctx.numbers}`,
        x1: "0.5",
        x2: "0.5",
        y2: "1",
        gradientUnits: "objectBoundingBox"
      }, [
        _hoisted_10,
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": _ctx.controlColor
        }, null, 8, _hoisted_11)
      ], 8, _hoisted_9)
    ]),
    _createElementVNode("g", _hoisted_12, [
      _createElementVNode("g", {
        id: "椭圆_401",
        "data-name": "椭圆 401",
        transform: "translate(88 297.227)",
        fill: "none",
        stroke: _ctx.controlColor,
        "stroke-width": "1",
        "stroke-dasharray": "8"
      }, _hoisted_16, 8, _hoisted_13),
      _createElementVNode("ellipse", {
        id: "椭圆_400",
        "data-name": "椭圆 400",
        cx: "40.537",
        cy: "4.625",
        rx: "40.537",
        ry: "4.625",
        transform: "translate(146.963 303.578)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_17),
      _createElementVNode("g", {
        id: "椭圆_397",
        "data-name": "椭圆 397",
        transform: "translate(96.5 112)",
        fill: _ctx.controlColor,
        stroke: _ctx.controlColor,
        "stroke-width": "1"
      }, _hoisted_21, 8, _hoisted_18),
      _createElementVNode("circle", {
        id: "椭圆_409",
        "data-name": "椭圆 409",
        cx: "86",
        cy: "86",
        r: "86",
        transform: "translate(99.5 114)",
        opacity: "0.5",
        fill: `url(#survey-svg-1-linear-gradient${_ctx.numbers})`
      }, null, 8, _hoisted_22),
      _createElementVNode("path", {
        id: "交叉_7",
        "data-name": "交叉 7",
        d: "M0,23.74c6.132-1.035,13.632-.848,22.584,1.755,30.562,8.884,51.686,18.635,95.7-9.487S174.2,5.371,174.2,5.371l.952.9A90.827,90.827,0,0,1,85.359,83.5,90.839,90.839,0,0,1,0,23.74Z",
        transform: "translate(101.979 210.014)",
        fill: `url(#survey-svg-1-linear-gradient-2${_ctx.numbers})`
      }, null, 8, _hoisted_23),
      _createElementVNode("path", {
        id: "交叉_5",
        "data-name": "交叉 5",
        d: "M0,38.688C22.6,47.029,59.061,53.9,88.767,28.659,123.145-.549,148.409-1.165,159.349.544A90.837,90.837,0,0,1,70.544,72.313,90.629,90.629,0,0,1,0,38.688Z",
        transform: "translate(116.889 221.203)",
        fill: `url(#survey-svg-1-linear-gradient-3${_ctx.numbers})`
      }, null, 8, _hoisted_24)
    ])
  ]))
}
}

})